var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('router-view'),_c('Nav'),_c('TrialModal'),(_vm.trialSuccModal.visible)?_c('TrialSuccModal'):_vm._e(),_c('DeviceDetail'),_c('FloatNav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }